import { useEffect, useState } from 'react';

import { BERRY_EVENT_ORIGIN, BERRY_APP_EVENT_HANDLERS_TYPES } from '../constant';
import { TBerry } from '../types';

declare var Berry: TBerry;

function useBerryHelpersEvent() {
  const [berryInitialised, setBerryInitialised] = useState(!!window?.Berry);
  const [widgetOpen, setWidgetOpen] = useState(false);

  const berryEventHandler = (event: MessageEvent) => {
    // Check the origin of the message for security
    if (event.origin !== BERRY_EVENT_ORIGIN && event.origin !== window.location.origin) {
      return;
    }
    const message = event.data;
    if (message.type === BERRY_APP_EVENT_HANDLERS_TYPES.BERRY_WIDGET_HANDSHAKE) {
      setBerryInitialised(true);
    } else if (message.type === BERRY_APP_EVENT_HANDLERS_TYPES.BERRY_WIDGET_STATE_CHANGED) {
      setWidgetOpen(!!message?.payload?.isOpen);
    }
  };

  useEffect(() => {
    window.addEventListener('message', berryEventHandler);
    return () => {
      window.removeEventListener('message', berryEventHandler);
    };
  }, []);

  const toggleBerry = () => {
    if (typeof Berry !== 'undefined') {
      Berry?.toggle();
    }
  };

  return {
    berryInitialised,
    widgetOpen,
    toggleBerry,
  };
}

export default useBerryHelpersEvent;
